import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CommonModal from "../based/Modal";
import CloseIcon from "./assets/CloseIcon.svg";
import CheckBox from "../based/inputs/CheckBox";
import PartnerServices from "../based/services/PartnerServices";
import { VOUCHER_DISCOUNT_TYPE } from "../based/Constants";

function CostModal({ show, onClose, onSave }) {
    const [lstGroupPartnerCostDiscount, setLstGroupPartnerCostDiscount] = useState([]);

    useEffect(() => {
        getGroupPartnerCostDiscount();
    }, []);

    const getGroupPartnerCostDiscount = async () => {
        const [err, data] = await PartnerServices.GetGroupPartnerCostDiscounts();
        if (!err && data) {
            setLstGroupPartnerCostDiscount(data);
        } else {
            setLstGroupPartnerCostDiscount([]);
        }
    };

    const getCost = async () => {
        const [err, data] = await PartnerServices.GetFlexibleFixedDiscountModel();
        return data;
    };

    const handleSave = async () => {
        let lst = [...lstGroupPartnerCostDiscount];
        let lstCost = [];
        lst.forEach((item) => {
            item.listCostSingle.forEach((cost) => {
                if (cost.isChecked) {
                    lstCost.push({
                        partnerCostDiscountId: cost.id,
                        editValue: 0,
                    });
                }
            });
        });
        const [err, data] = await PartnerServices.CreateUpdatePartnerCostDiscountSelected(lstCost);
        if (!err && data) {
            //lấy ra chi phí
            const cost = await getCost();
            onSave(cost);
        } else {
            onClose();
        }
    };

    return (
        <CommonModal show={show} onClose={onClose} hiddenFooter hideClose>
            <Wrapper>
                <section className="header-modal">
                    <h4>Tùy chọn tham gia các loại phí</h4>
                    <div className="icon" onClick={onClose}>
                        <img src={CloseIcon} alt="" />
                    </div>
                </section>
                <section className="body-modal">
                    <div className="instruction">
                        <p>
                            <span className="high-light">Lưu ý:</span>
                            <br />
                            Các tùy chọn chỉ giúp nhà bán hàng tính được lợi nhuận gộp gần đúng nhất. Không giúp nhà bán hàng tham gia các chương trình trên Tiktokshop.
                        </p>
                    </div>
                    <section className="list-discount">
                        {lstGroupPartnerCostDiscount &&
                            lstGroupPartnerCostDiscount.length > 0 &&
                            lstGroupPartnerCostDiscount.map((item, index) => {
                                return (
                                    <div className="discount-item" key={index}>
                                        <label htmlFor="">{item.discountTypeName}</label>
                                        {item.listCostSingle &&
                                            item.listCostSingle.length > 0 &&
                                            item.listCostSingle.map((cost, i) => {
                                                let discount = cost.valueType == VOUCHER_DISCOUNT_TYPE.PERCENTAGE ? `${cost.shopValue}%` : `${cost.shopValue}đ`;
                                                return (
                                                    <div className="discount-text" key={i}>
                                                        <CheckBox
                                                            checked={cost.isChecked}
                                                            name={`cost_checked_${cost.id}`}
                                                            onCheckedChange={(name, value) => {
                                                                const newList = [...lstGroupPartnerCostDiscount];
                                                                newList[index].listCostSingle[i].isChecked = value;
                                                                setLstGroupPartnerCostDiscount(newList);
                                                            }}
                                                        />
                                                        <span>
                                                            {cost.name} ({discount})
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                );
                            })}
                    </section>
                </section>

                <section className="bottom-modal">
                    <div className="left-bottom">{/* <span className="high-light">Tổng 31.05%</span> */}</div>
                    <div className="right-bottom">
                        <button className="btn btn-cancel" onClick={onClose}>
                            Đóng
                        </button>
                        <button className="btn btn-orange" onClick={handleSave}>
                            Xác nhận
                        </button>
                    </div>
                </section>
            </Wrapper>
        </CommonModal>
    );
}

export default CostModal;

const Wrapper = styled.div`
    section.bottom-btn {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 10px;
    }

    section.body-modal {
        overflow: auto;
        height: 70vh;
    }

    section.header-modal {
        display: flex;
        align-items: center;
        padding: 12px 10px;
        border: 1px solid #f3f3f3;
        background: #fff;
    }

    section.header-modal h4 {
        margin: 0 0 0 auto;
        color: #333;
        text-align: center;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }

    section.header-modal .icon {
        display: flex;
        margin: 0 0 0 auto;
    }

    .instruction {
        border-radius: 8px;
        background: #fff5ec;
        margin: 12px 24px;
        padding: 10px;
    }

    .instruction p {
        margin: 0;
        color: #707070;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .instruction p .high-light {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 4px;
    }

    section.list-discount {
        margin: 12px 24px;
    }

    .discount-item label {
        margin: 0;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .discount-item {
        margin: 10px 0;
    }

    .discount-text {
        color: #444;
        font-family: Lexend;
        font-size: 13px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 153.846% */
        margin: 10px 0 10px 8px;
        display: flex;
        align-items: baseline;
    }

    section.bottom-modal {
        display: flex;
        align-items: center;
        border: 1px solid #f3f3f3;
        background: #fff;
        box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.1);
        padding: 14px 24px;
    }

    .right-bottom {
        margin-left: auto;
    }

    .left-bottom .high-light {
        color: #ff9027;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    button.btn.btn-cancel {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #f3f3f3;
        margin: 0 10px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin: 0 10px;
    }
`;
